// caseHomeState — what Case Home shows when it has no current case (TEST 1.38, P17 step 2).
//
// ★★ THE DEFECT. Case Home rendered "No Cases Yet" whenever `currentCase` was null, whatever
//    the account held. After a PIN unlock on /case/home a patient WITH cases saw the empty
//    state: every loadCases() in Case Home sat behind `currentCase?.id`, so with no current
//    case nothing loaded, and nothing told the screen the list was not empty.
//    What nulls `currentCase` after an unlock was NOT reproduced; this makes the empty state
//    honest, it does not claim the cause.
//
// ★ THE RULE (one owner, import-free so a gate can execute it):
//      a current case                      -> 'case'    (render it)
//      cases on the account, none selected -> 'toList'  (go to /cases; never pick one, P17 Q4)
//      the one load has not settled        -> 'loading' (the branded loader)
//      otherwise                           -> 'empty'   (today's "No Cases Yet")
//
// ★ DELIBERATELY NOT `casesLoading`. The case store sets it true again on every rehydrate and
//    on resetForUser, and only loadCases sets it false. A view gated on it spins for ever when
//    a load never settles. `loadSettled` is Case Home's own flag, set in the load's `finally`.
export function caseHomeView({ currentCase, caseCount, loadSettled } = {}) {
  if (currentCase) return 'case'
  const n = Number.isFinite(caseCount) ? caseCount : 0
  if (n > 0) return 'toList'
  if (!loadSettled) return 'loading'
  return 'empty'
}
